import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "hiddenField", "counter", "frame"]
  static values = { hiddenId: String }

  connect() {
    // Listen for turbo-frame updates to re-apply selections
    this.element.addEventListener("turbo:frame-load", this.onFrameLoad.bind(this))
    this.syncCounter()
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.onFrameLoad.bind(this))
  }

  onFrameLoad() {
    // After turbo-frame renders new seguros, pre-check those already selected
    const selectedIds = new Set(this.selectedIds)
    this.itemTargets.forEach(item => {
      const checkbox = item.querySelector("input[type=checkbox]")
      if (!checkbox) return
      const id = checkbox.value
      const wasSelected = selectedIds.has(id)
      checkbox.checked = wasSelected
      item.classList.toggle("checked", wasSelected)
    })
    this.syncCounter()
  }

  checkboxChanged(event) {
    const label = event.target.closest("[data-seguro-select-target='item']")
    if (label) label.classList.toggle("checked", event.target.checked)
    this.syncHiddenField()
    this.syncCounter()
  }

  syncHiddenField() {
    this.hiddenField.value = this.selectedIds.join(",")
  }

  syncCounter() {
    const count = this.selectedIds.length
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${count} selecionado${count === 1 ? "" : "s"}`
      this.counterTarget.style.color = count > 0 ? "var(--accent)" : "var(--text-muted)"
    }
  }

  get hiddenField() {
    if (this.hasHiddenFieldTarget) return this.hiddenFieldTarget
    // Fallback: find by ID (when hidden field is in a sibling form)
    const id = this.hiddenIdValue || "seguro-grupo"
    return document.getElementById(id)
  }

  get selectedIds() {
    const value = this.hiddenField?.value || ""
    return value.split(",").map(s => s.trim()).filter(Boolean)
  }
}
